import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {AppVersion} from "@ionic-native/app-version";

/*
  Generated class for the AppServiceProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class AppServiceProvider {

  defaultPackageName: any = 'com.tuipoint.app';

  constructor(
    public http: HttpClient,
    private appVersion: AppVersion,
  ) {

  }

  dataForAppByPackageName(){

    return new Promise((resolve, reject)=>{
      this.getPackageName().then(packageName=>{
        this.http.post(`/app-data`, {
          'package_name' : packageName
        }).subscribe((data: any) => {
          return resolve(data);
        }, error => {
          return reject(error.message);
        });
      });
    });

  }

  getPackageName(){

    return new Promise((resolve,reject)=>{
      this.appVersion.getPackageName().then(packageName=>{
        return resolve(packageName);
      }).catch(error=>{
        return resolve(this.defaultPackageName);
      });
    });

  }

}



// WEBPACK FOOTER //
// ./src/providers/app-service/app-service.ts